const timeLogReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default timeLogReducer;